export default __webpack_public_path__ + "static/logo-5-47a402b156c2d238e1f59ce4c4b83034.webp";